var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-0 p-0"},[_c('b-form-group',{attrs:{"label":"Filtrar por NSU:","label-for":"filter-nsu"}},[_c('b-form-input',{attrs:{"id":"filter-nsu","placeholder":"Digite o NSU para filtrar"},model:{value:(_vm.nsuFilter),callback:function ($$v) {_vm.nsuFilter=$$v},expression:"nsuFilter"}})],1),_c('b-table',{staticClass:"text-center",attrs:{"per-page":8,"hover":"","current-page":_vm.page,"responsive":"","items":_vm.filteredItems,"fields":[
        {
          key: 'nsu',
          label: 'NSU'
        },
        {
          key: 'transactionDate',
          label: 'Data da Transação'
        },
        {
          key: 'chargebackId',
          label: 'id do chargeback'
        },
        {
          key: 'incomingDate',
          label: 'Data da Solicitação'
        },
        {
          key: 'processNumber',
          label: 'Número do Processo'
        },
        {
          key: 'status',
          label: 'Status'
        },
        {
          key: 'value',
          label: 'Valor'
        },
        {
          key: 'postedRate',
          label: 'Taxas'
        } ]},on:{"row-clicked":function (item) { return _vm.$emit('row-clicked', item.chargebackId ,item.nsu, item.transactionDate); }},scopedSlots:_vm._u([{key:"cell(transactionDate)",fn:function(data){return [_vm._v(" "+_vm._s(_vm._f("date")(data.item.transactionDate))+" ")]}},{key:"cell(incomingDate)",fn:function(data){return [_vm._v(" "+_vm._s(_vm._f("date")(data.item.incomingDate))+" ")]}},{key:"cell(value)",fn:function(data){return [_vm._v(" "+_vm._s(_vm._f("value")(data.item.value))+" ")]}},{key:"cell(postedRate)",fn:function(data){return [_vm._v(" "+_vm._s(data.item.postedRate ? 'Sim' : 'Não')+" ")]}}])}),_c('b-pagination',{staticClass:"my-2",attrs:{"total-rows":_vm.filteredItems.length,"per-page":8,"align":"center","size":"sm"},model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }